import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-137" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-138" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-139" data-mp="3fyvxs9ef7bak">
          What Dance Educators Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-140" data-mp="36ypqx6d899kd">
          <span aria-hidden="true" data-id="element-141" data-mp="36wmotnysvpza">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1,500 dance
          educators
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-142" data-mp="3228xpxr6850f">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-143" data-mp="2s1yp6qg2zlrl">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-144" data-mp="v85a7yk6bf3b">
                <span aria-hidden="true" data-id="element-145" data-mp="qbesl6sq0bfs">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-146" data-mp="h681ea14tyd0">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-147" data-mp="m2oor20ic8p1">
                <p className="text-xs font-bold text-ink" data-id="element-148" data-mp="78tvv5gqytzh">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-149" data-mp="c6ljhnacztxv">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-150" data-mp="zwy2bt757b38">
          Illustrative testimonials shown for demonstration purposes.
        </p>
      </div>
    </section>;
}